import React from 'react';
import { NotificationImportant, BorderColor } from '@mui/icons-material';

type NotificationTextProps = {
  note: string | TrustedHTML;
  backgroundColor?: string;
};

export const NotificationText: React.FC<NotificationTextProps> = (
  props: NotificationTextProps,
) => {
  const { note, backgroundColor = '#f5f5f5' } = props;
  return (
    <div
      style={{
        width: '100%',
        fontSize: '1rem',
        backgroundColor,
        padding: '0.5rem 1rem',
        textAlign: 'left',
        fontStyle: 'italic',
        fontWeight: 500,
      }}
    >
      <NotificationImportant
        style={{
          color: '#951d1d',
          fontSize: '1.5rem',
        }}
      />
      <span
        style={{
          fontStyle: 'italic',
          margin: '0 0 0 0.5rem',
        }}
        dangerouslySetInnerHTML={{
          __html: note,
        }}
      />
    </div>
  );
};

type RemarksNotificationTextProps = NotificationTextProps & {
  remarksTitle: string;
};

export const RemarksNotificationText: React.FC<RemarksNotificationTextProps> = (
  props: RemarksNotificationTextProps,
) => {
  const { note, remarksTitle, backgroundColor = '#E1C0C0' } = props;
  return (
    <div
      style={{
        width: '100%',
        fontSize: '1rem',
        backgroundColor,
        padding: '0.5rem 1rem',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '3px',
      }}
    >
      <BorderColor
        style={{
          color: '#951d1d',
          fontSize: '1.5rem',
          marginRight: '0.5rem',
        }}
      />
      <div className="flex flex-col">
        <div className="font-bold">{remarksTitle}</div>
        <div
          className="py-2"
          dangerouslySetInnerHTML={{
            __html: note,
          }}
        />
      </div>
    </div>
  );
};
